import {IOrganizationUserInfo, IUserTable} from '@/utils/types';
import {StoreType} from '..';

export const getUserSelector = (state: StoreType): IOrganizationUserInfo | null => state.userStore.userInfo;

export const getUserIdSelector = (state: StoreType): number | undefined => state.userStore.userInfo?.id;

export const getUserIsLoadingSelector = (state: StoreType): boolean => state.userStore.isLoading;

export const getUserTablesSelector = (state: StoreType): IUserTable[] | [] => state.userStore.userTables;
